//import { NonCatalogProductSelection } from "../components/NonCatalogProductSelection/NonCatalogProductSelection";
import { useAppSettings } from "../providers/appSettingsProvider";

import { JSX } from "react";

import {
  VMConfigurationStates,
  useGetByIdLineItems,
  useGetByIdLineItemsKey,
} from "@4pace-cpq/core/api";
import { Box } from "@mui/material";
import { useSearch } from "@tanstack/react-router";

import { Configurator } from "./Configurator";
import ConfiguratorLoadingCurtain from "./ConfiguratorLoadingCurtain";
import { ConfigurationPreselector } from "./preselector/ConfigurationPreselector";

export default function ConfiguratorContainer(): JSX.Element {
  const { doInitialRedirect, setDoInitialRedirect } = useAppSettings();
  const { cfgObjectId, lineItemId } = useSearch({
    from: "/configurator",
  });

  if (doInitialRedirect) {
    setDoInitialRedirect(false); //disables the redirect in CustomCartIdRouteComponent.tsx
  }

  const { data: lineItem } = useGetByIdLineItems(
    {
      path: { id: lineItemId },
      query: { Includes: "Configuration,Configuration.ConfigurationState" },
    },
    [useGetByIdLineItemsKey, lineItemId],
    {
      enabled: !!lineItemId,
    },
  );

  if (lineItemId && !lineItem) {
    return <></>;
  } else if (lineItemId) {
    //if has a lineItemId, then it is a loaded configuration
    const configurationState: VMConfigurationStates | null | undefined =
      lineItem?.configuration?.configurationState;
    const configurationSave = configurationState?.configurationSave;
    const configurationObj = configurationSave?.configuration;

    if (configurationObj && configurationObj?.id) {
      const cfgObjectId = configurationObj?.id;
      let stateJSON;
      try {
        stateJSON = JSON.stringify(configurationSave);
      } catch (e) {
        console.error("Couldn't parse the cfgState", { lineItem, e });
        return <></>;
      }

      return (
        <Box position="relative">
          {lineItemId ? <ConfiguratorLoadingCurtain /> : <></>}
          <Configurator
            cfgObjectId={cfgObjectId}
            state={stateJSON}
            //productSelection={productSelection}
          />
        </Box>
      );
    }
  } else if (cfgObjectId) {
    //has no lineItem and a product id, means it is not in a lineItem yet, so a new configuration is started
    return (
      <Configurator
        cfgObjectId={cfgObjectId}
        //productSelection={productSelection}
      />
    );
  } else {
    return <ConfigurationPreselector />;
  }
  return <></>;
}
